<script>
export default {
  props: {
    item: Object,
  },
  methods: {
    getHref(item) {
      return `/tourclient/admin/orders/info.html?code=${item.AgreementCode}`;
    },
  },
};
</script>
<template>
  <v-list-item
    class="mag-template-message__item"
  >
    <v-list-item-content>
      <v-list-item-title>Путевка: {{ item.AgreementCode }} {{item.CorrespondenceTypeName || ''}}</v-list-item-title>
      <v-list-item-subtitle>от: {{item.UserName}}</v-list-item-subtitle>
      <v-list-item-subtitle
        v-text="item.MessagePreview"></v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-btn
        :href="getHref(item)"
        title="Перейти к путевке"
        color="blue-grey"
        icon
      >
        <v-icon v-text="'mdi-clipboard-arrow-right-outline'"></v-icon>
      </v-btn>
    </v-list-item-action>
    <v-list-item-action>
      <v-btn
        title="Ответить"
        @click="$emit('open', item)"
        color="blue"
        icon
      >
        <v-icon v-text="'mdi-forum'"></v-icon>
      </v-btn>
    </v-list-item-action>
    <v-list-item-action>
      <v-btn
        title="Скрыть"
        icon
        @click="$emit('close', item)"
        color="red"
      >
        <v-icon v-text="'mdi-close-circle-outline'"></v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>
<style lang="scss">

</style>
